import { render, staticRenderFns } from "./SetUser.vue?vue&type=template&id=6c8708fd&scoped=true"
import script from "./SetUser.vue?vue&type=script&lang=js"
export * from "./SetUser.vue?vue&type=script&lang=js"
import style0 from "./SetUser.vue?vue&type=style&index=0&id=6c8708fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8708fd",
  null
  
)

export default component.exports